import styled from 'styled-components';

import { TooltipWrapperStyled } from 'approot/shared/tooltip/tooltip.style';

type BadgeActivityMediaTypeWrapperProps = {
  $colour?: string;
};

export const BadgeActivityMediaTypeWrapper = styled.div<
  BadgeActivityMediaTypeWrapperProps
>`
  ${TooltipWrapperStyled} {
    span {
      display: inline-block;
      vertical-align: middle;

      svg,
      &:focus svg {
        ${({ $colour }) => $colour && `stroke: ${$colour};`}
      }

      &:focus {
        ${({ $colour }) => $colour && `outline: 1px solid ${$colour};`}
      }
    }
  }
`;
